module.exports = __webpack_public_path__ + "img/token.9c91d3a7.png";